import React from "react";
import { bonuses } from "../data/landing";
import { BonusCover } from "./BonusCover";
export function BonusesSection() {
  return <section className="section" id="bonuses" data-id="element-2" data-mp="gx6nq4w9ya9e">
      <div className="shell" data-id="element-3" data-mp="vsmm2m3w0sbl">
        <div className="section-intro" data-id="element-4" data-mp="vtxmcby4jhxy">
          <p className="eyebrow" data-id="element-5" data-mp="vqtcoz1w3tzw">5 BONUSES INCLUDED IN YOUR $27 KIT</p>
          <h2 data-id="element-6" data-mp="qt045zd46nwg">
            The work around the session.
            <br data-id="element-7" data-mp="14tb0vj13uwpj" />
            <span data-id="element-8" data-mp="14sstprcwmy2u">Prepared too.</span>
          </h2>
          <p data-id="element-9" data-mp="14rhtu2mkyah0">Resources to help you choose where to start, schedule the practice and keep it going between sessions.</p>
        </div>
        <ul className="bonus-grid" data-id="element-10" data-mp="1ejx9uuebgoz9">
          {bonuses.map((bonus, i) => {
          const number = `0${i + 1}`;
          return <li key={bonus.title} data-id="element-11" data-mp="19kszi0fnol7c" data-mpi={i}>
                <div className="bonus-media" data-id="element-12" data-mp="1nk256668jwx2">
                  <BonusCover number={number} title={bonus.title} tone={bonus.tone} data-id="element-13" data-mp="1nkvfti8bf6kh" />
                </div>
                <div className="bonus-body" data-id="element-14" data-mp="1jjs2p3hnjomy">
                  <p className="eyebrow" data-id="element-15" data-mp="3pqbsd9gp4t02">BONUS {number}</p>
                  <h3 data-id="element-16" data-mp="3prwlqvr9y5wc">{bonus.benefit}</h3>
                  <h4 data-id="element-17" data-mp="3trx770csjhcw">{bonus.title}</h4>
                  <p data-id="element-18" data-mp="3tsouzp05casm">{bonus.text}</p>
                </div>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}